var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchFormat, timeoutPromise } from './utils/index.js';
const DEFAULT_FETCH_TIMEOUT = 8000;
export class FetchRequest {
    constructor(defaults) {
        this._defaults = defaults;
    }
    send(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const { headers, baseURL, url, method, timeout = DEFAULT_FETCH_TIMEOUT } = this._defaults || {};
            const _config = Object.assign({}, config);
            _config.headers = Object.assign(Object.assign({}, headers), _config.headers);
            _config.method = _config.method || method;
            _config.url = _config.url || url;
            if (baseURL)
                _config.url = baseURL + _config.url;
            const control = new AbortController();
            const result = yield Promise.race([fetchFormat(_config, control.signal), timeoutPromise(timeout)]);
            if ((result === null || result === void 0 ? void 0 : result.type) === 'timeout') {
                if (control.abort)
                    control.abort();
                throw new Error('fetch timeout');
            }
            return result;
        });
    }
}
